















































































































import { Vue, Component, Prop } from "vue-property-decorator";

import ObjectEditLayout from "@service/layouts/ObjectEditLayout.vue";
import FormGroup from "@share/common/form/form-group/FormGroup.vue";
import FormRow from "@share/common/form/form-row/FormRow.vue";
import SingleSelect from "@share/common/form/form-controls/select/variations/single-select/SingleSelect.vue";
import BorderlessText from "@share/common/form/form-controls/text/BorderlessText.vue";
import BorderlessTextarea from "@share/common/form/form-controls/text/BorderlessTextarea.vue";
import TzSelector from "@share/common/tz-selector/TZ-selector.vue";
import DateTimeControl from "@share/common/form/form-controls/date/date-time/DateTimeControl.vue";
import PeopleSelect from "@share/common/form/form-controls/select/people-select/PeopleSelect.vue";

import { CommitteeFormModelInterface } from "@share/committees/committee-form/types/CommitteeFormModel";
import { SelectDataService } from "@share/committees/committee-form/services/select/CommitteeSelectDataService";

import TimeCircle from "../../../../../assets/svg/time-circle.svg";
import { DateTime } from "luxon";
import { SelectObjectSourceService } from "@share/common/services/selectControl/SelectObjectSourceService";
import { SelectUsersSourceService } from "@share/common/services/selectControl/SelectUsersSourceService";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { DropDownItem } from "@share/common/drop-down/types";
import { getSubjectsList } from "@share/committees/committee-form/data";
import { ObjectFields, UserFields } from "@share/committees/committee-form/types";
import { ValidationGroups, ValidationProperties } from "vue/types/vue";
import { Validation } from "vuelidate";
import { companyConverter } from "@api/models/objects/Converters";
import { RootState } from "@service/store/types/RootState";
import { mainActions } from "@service/store/main/actions";


@Component({ components: {
    ObjectEditLayout, FormGroup, FormRow,
    SingleSelect, BorderlessText, BorderlessTextarea,
    TzSelector, DateTimeControl, PeopleSelect, TimeCircle
}})
export default class Step1Information extends Vue {

    @Prop({ required: true }) formModel: CommitteeFormModelInterface;
    @Prop() $v: ValidationProperties<Vue> & ValidationGroups & Validation;

    subjectSelectSource: DropDownItem[] = getSubjectsList();

    private readonly COMPANY_SCHEMA_ID = process.env.VUE_APP_COMPANY_STRUCTURE_SCHEMA || 'CompanyStructure';

    // SERVICES:
    selectObjectDataService: SelectDataService<ObjectFields> =
        new SelectDataService<ObjectFields>(
            new SelectObjectSourceService(
                this.$repositories.get(RepositoryFabric.OBJECT),
                companyConverter,
                [{ parentId: ['title'] }]
            )
        );

    selectUsersDataService: SelectDataService<UserFields> =
        new SelectDataService<UserFields>(
            new SelectUsersSourceService(
                this.$repositories.get(RepositoryFabric.USER),
                ['userId', 'firstName', 'lastName', 'direction', 'position']
            )
        );

    subjectSearch(keyword = "") {
        if(!keyword) {
            this.subjectSelectSource = getSubjectsList();
        }
        else {
            this.subjectSelectSource = getSubjectsList().filter((item) => item.title.toLowerCase().includes(keyword.toLowerCase()))
        }
    }

    companySearch(keyword = "") {
        this.selectObjectDataService.updateSource("company", { keyword, schemaId: this.COMPANY_SCHEMA_ID });
    }

    secretarySearch(keyword = "") {
        this.selectUsersDataService.updateSource("secretary", { keyword });
    }

    updateBegin(date: DateTime) {
        if(date.isValid) {
            this.formModel.beginAt = date;
        }
    }

    updateEnd(date: DateTime) {
        if(date.isValid) {
            this.formModel.endAt = date;
        }
    }

    get selectedTimeZone() {
        return (this.$store.state as RootState).selectedTimeZoneOffset?.toString() || "";
    }

    set selectedTimeZone(value: string) {
        this.$store.dispatch(mainActions.setSelectedTimeZone, value);
    }

    get vModel(): Validation & ValidationProperties<CommitteeFormModelInterface> {
        return this.$v.formModel
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    get controlHelpMessage() {
        return this.$t('common.enterForSearch').toString()
    }
}

